var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNavGroup(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 21 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: "100%",
    height: "100%",
    preserveAspectRatio: "none",
    "data-testid": "custom-icon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.0909 4.77258C17.7068 4.77258 16.9336 6.14713 17.2486 7.16849L13.86 10.5667C13.5736 10.4808 13.1536 10.4808 12.8673 10.5667L10.4332 8.13258C10.7577 7.11122 9.98455 5.72713 8.59091 5.72713C7.20682 5.72713 6.42409 7.10167 6.74864 8.13258L2.39591 12.4758C1.37455 12.1608 0 12.9339 0 14.318C0 15.368 0.859091 16.2271 1.90909 16.2271C3.29318 16.2271 4.06636 14.8526 3.75136 13.8312L8.09454 9.47849C8.38091 9.5644 8.80091 9.5644 9.08727 9.47849L11.5214 11.9126C11.1968 12.9339 11.97 14.318 13.3636 14.318C14.7477 14.318 15.5305 12.9435 15.2059 11.9126L18.6041 8.52395C19.6255 8.83895 21 8.06576 21 6.68167C21 5.63167 20.1409 4.77258 19.0909 4.77258Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3636 5.72727L14.2609 3.75136L16.2273 2.86364L14.2609 1.97591L13.3636 0L12.4855 1.97591L10.5 2.86364L12.4855 3.75136L13.3636 5.72727Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.38636 7.63637L2.86364 5.72728L4.77273 5.25001L2.86364 4.77274L2.38636 2.86365L1.90909 4.77274L0 5.25001L1.90909 5.72728L2.38636 7.63637Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavGroup);
export default __webpack_public_path__ + "static/media/nav-group.508725d3.svg";
export { ForwardRef as ReactComponent };